var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"mt-4",attrs:{"fluid":_vm.$vuetify.breakpoint.mdOnly}},[_c('div',{staticClass:"text-h4"},[_vm._v("Fornecedores")])])}
var staticRenderFns = []

export { render, staticRenderFns }